import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import MultiColumnLayout from '../../Shared/MultiColumnLayout';
//
import quotes from '../../../../images/quotes-icon.svg';

// * Main background wrapper
export const Wrapper = styled.div`
  background-color: ${({ colourOverrideBackground }) =>
    colourOverrideBackground || themeGet('colors.neutral_1')};

  & + .awards-banner {
    margin-top: -60px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    & + .awards-banner {
      margin-top: -60px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    & + .awards-banner {
      margin-top: -90px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    & + .awards-banner {
      margin-top: -90px;
    }
  }
`;

// * Grid container
export const StyledContainer = styled(Container)`
  padding: 50px 0 60px;

  // * Section title
  > h1,
  > h2,
  > h3,
  > h4,
  > h5,
  > h6,
  > p {
    color: ${themeGet('colors.text-secondary')};
    text-align: center;
    margin-bottom: 30px;

    ${Wrapper}.text-dark & {
      color: ${themeGet('colors.text-secondary')};
    }
    ${Wrapper}.text-light & {
      color: ${themeGet('colors.text-primary')};
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 50px 90px 60px;

    > h1,
    > h2,
    > h3,
    > h4,
    > h5,
    > h6,
    > p {
      padding-left: 120px;
      padding-right: 120px;

      margin-bottom: 40px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    display: block;
    padding: 70px 0px 90px;

    > h1,
    > h2,
    > h3,
    > h4,
    > h5,
    > h6,
    > p {
      margin-bottom: 50px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 70px 45px 90px;
  }
`;

export const Columns = styled(MultiColumnLayout)`
  @media only screen and (max-width: calc(${themeGet(
    'breakpoints.lg'
  )} - 1px)) {
    margin-left: 0;
    margin-right: 0;
  }
`;

// * Each testimonial Card
export const Card = styled.div`
  border-radius: 12px;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0 calc(${themeGet('media.grid-gutter.2')} / 2) 0;

  background-color: ${({ colourOverrideCardBG }) =>
    colourOverrideCardBG || themeGet('colors.neutral_2')};

  // * Orange quote img above testimonial
  &::after {
    content: "";
    position: absolute;
    top: 26.5px;
    background-image: url(${quotes});
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;

    height: 60px;
    width: 76px;
  }

  // * Padding at the bottom of the card to support the image
  ${Wrapper}.with-image & {
    padding-top: 113px;
    padding-bottom: 80px;
    margin-bottom: 103px;
  }

  hr {
    color: ${themeGet('colors.secondary')};
    margin: 30px 0;
  }

  // * The image at the bottom of each card
  &::before {
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translate(-50%, 50%);
    content: '';
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${({ image }) => image});

    height: 126px;
    width: 100%;
  }

  @media (min-width: ${themeGet('breakpoints.md')}) and (max-width:${themeGet(
  'breakpoints.lg'
)}) {
    /* for IE */
    width: 100%;
}

  @media only screen and (max-width: calc(${themeGet(
    'breakpoints.lg'
  )} - 1px)) {
    && {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 535px;
    && {
      padding-left: 60px;
      padding-right: 60px;
    }


    ${Wrapper}.with-image & {
      // * The image at the bottom of each card
      &::before {
        position: absolute;
        transform: translate(-50%, 50%);
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    && {
      padding: 128px 40px 90px;
    }

    ${Wrapper}.with-image & {
      padding: 113px 40px 100px;
      // * Orange quote img above testimonial
        &::after {
          height: 60px;
          width: 76px;
        }
    }

    &::before {
      height: 180px;
      width: 180px;
      left: 50%;
      bottom: 0;
      transform: translate(-50%, 50%);
    }
  }
`;

// * Body Copy of the testimonal
export const Testimonial = styled.p`
  color: ${themeGet('colors.text-secondary')};
  font-family: ${themeGet('fonts.primary')};
  font-size: 16px;
  letter-spacing: 0;
  line-height: 26px;
  margin-bottom: 20px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 18px;
    line-height: 30px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;

// * Testimonail author
export const Author = styled.p`
  color: ${themeGet('colors.orange')};
  font-family: ${themeGet('fonts.primary')};
  font-size: 26px;
  font-weight: bold;
  letter-spacing: -0.5px;
  line-height: 38px;
  margin-bottom: 15px;

  &::before {
    content: '';
    display: block;
    border-top: 2px solid ${themeGet('colors.black')};
    width: 100%;
    max-width: 79px;

    margin-bottom: 15px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    position: relative;
    margin-top: auto;
    margin-bottom: 10px;

    &::before {
      content: '';
      display: block;
      border-top: 2px solid ${themeGet('colors.black')};
      width: 100%;
      max-width: 79px;

      margin-bottom: 15px;
    }
  }
`;

// * Category of author
export const AuthorRelation = styled.p`
  color: ${themeGet('colors.text-secondary')};
  font-size: 18px;
  letter-spacing: -0.2px;
  line-height: 30px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;
